// extracted by mini-css-extract-plugin
export default {"element":"x","fromLeft":"y","fromRight":"z","fromBelow":"A","fromAbove":"B","appear":"C","blinking":"D"};